import React, { useState } from "react";
import { DocumentCard, 
    DocumentCardDetails, 
    DocumentCardTitle, 
    DocumentCardActivity,
    DefaultButton, 
    TooltipHost,
    Icon} from '@fluentui/react';
import EditModal from "../EditSite/EditModal";
import { PowerAppProvisioningStatus } from "../../GlobalConst/globalEnums";
import { mapUserForPeople, renderDateTime } from "../../helpers/HelperMethods";
import PowerAppSolutionEnvs from "./PowerAppSolutionEnvs";

const SinglePowerAppSolution = ({solution, callBack}) => {

    const [showModal, setShowModal] = useState(false)

    const _onEditClick = () => {
        setShowModal(true)
    }

    const _closeModal = () => {
        setShowModal(false)
    }

    const updatesIcon = [PowerAppProvisioningStatus.updating, PowerAppProvisioningStatus.pendingApproval, PowerAppProvisioningStatus.failed, PowerAppProvisioningStatus.permanentFailed, PowerAppProvisioningStatus.partiallyFailed].includes(solution.provisioningStatus) &&
        <TooltipHost content='Updates are in progress' styles={iconStyles}>
            <Icon iconName='workflow' style={updatesIconStyles} />
        </TooltipHost>

    const btnEdit = !updatesIcon && <DefaultButton text='Details' onClick={_onEditClick} styles={btnEditStyles}/>
    
    const managedSolutionIcon = <TooltipHost content={solution.isManagedSolution ? 'Managed solution' : 'Unmanaged solution'} styles={iconStyles}>
                                    <Icon iconName={solution.isManagedSolution ? 'lockSolid' : 'unlock'} style={managedSolutionIconStyles} />
                                </TooltipHost>

    const isUsingAiFeaturesBanner = 
            solution.isUsingAiFeatures &&
            <div style={{backgroundColor: '#ff9600', color: 'white', padding: '5px 8px', fontSize: '14px'}}>
                Uses AI features (may incur cost)
            </div>

    const customBorder =
            solution.isUsingAiFeatures
                ? '1px solid #ff9600'
                : null   

    return (
        <div>
            <DocumentCard styles={cardStyles(customBorder)} >
                {isUsingAiFeaturesBanner}
                <DocumentCardDetails styles={detailsStyles} >
                    <div style={headerStyles}>
                        {managedSolutionIcon}
                        <div style={titleContainerStyles}>
                            <DocumentCardTitle title={solution.name} shouldTruncate={true} styles={titleStyles} />
                        </div>
                        <div style={iconContainerStyles}>
                            {updatesIcon}
                            {btnEdit}
                        </div>
                    </div>
                    <div style={ownersStyles}>
                        <DocumentCardActivity 
                            activity={`Primary owner`} 
                            people={mapUserForPeople(solution.primaryOwner)}
                            styles={ownerStyles}
                        />
                        <DocumentCardActivity 
                            activity={`Secondary owner`} 
                            people={mapUserForPeople(solution.secondaryOwner)} 
                            styles={ownerStyles}
                        />
                    </div>
                    <div style={descriptionStyles}>
                        <label style={labelStyles}>Description:</label>
                        <div>
                            {solution.description}
                        </div>
                    </div>
                    <div style={recerfiticationStyles}>
                        <label style={labelStyles}>Last recertification:</label>
                        <DocumentCardActivity 
                            activity={solution.lastRecertificationDate ? `Last recertified on ${renderDateTime(solution.lastRecertificationDate)}` : 'No recertification'} 
                            people={mapUserForPeople(solution.lastRecertifiedBy)}
                        />
                    </div>
                    {/* <div style={expirationStyles}>
                        <label style={labelStyles}>Expiration Date: </label><span>{renderDate(solution.expirationDate)}</span>
                    </div> */}
                    <div>
                        <div>
                            <PowerAppSolutionEnvs environments={solution.environments} />
                        </div>
                        {/* <div style={rightColumnStyles}>
                            <PowerAppSolutionApps apps={solution.apps} />
                        </div> */}
                    </div>
                </DocumentCardDetails>
            </DocumentCard>
            <EditModal 
                onCloseModal={_closeModal} 
                isModalOpened={showModal} 
                itemId={solution.id}
                callBack={callBack}
                isPowerAppSolution={true}
            />
        </div>
    );
}
const managedSolutionIconStyles = {
    fontSize: 16
}

const labelStyles = {
    fontWeight: 600
}

const recerfiticationStyles = {
    marginTop: 16
}

const ownerStyles = {
    root: {
        width: 200
    }
}

const ownersStyles = {
    display: 'flex',
    justifyContent: 'space-between'
}

const descriptionStyles = {
    height: '50px',
    marginTop: 16,
    overflow: 'auto',
    wordWrap: 'break-word'
}

const btnEditStyles = {
    root: {
        margin: '6px 0 6px 6px',
        height: '24px',
        minWidth: '40px'
    },
    label: {
        fontWeight: 400
    }
}

const iconContainerStyles = {
    display: 'flex'
}

const iconStyles = {
    root: {
        margin: '10px 10px 10px 0'
    }
}

const updatesIconStyles = {
    color: 'orange'
}

const headerStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const cardStyles = (border) => ({
    root: {  
        marginRight: 20, 
        marginBottom: 20, 
        width: 500,
        maxWidth: 500,
        height: 415,
        border: border ? border : '1px solid rgb(138, 136, 134)',
        fontSize: 12,
    },
})

const detailsStyles = {
    root: {
        marginBottom: 20,
        marginTop: 5,
        paddingLeft: 16,
        paddingRight: 16
    }
}

const titleContainerStyles = {
    display: 'flex',
    height: 54,
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
}

const titleStyles = {
    root: {
        flexGrow: 1,
        padding: '8px 0'
    }
}

export default SinglePowerAppSolution


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SinglePowerAppSolution.js